import { Pipe, PipeTransform } from '@angular/core';
import { StatusCodeLabels } from '../constants/status-code.enum';

@Pipe({
  name: 'status'
})
export class StatusPipe implements PipeTransform {

  transform(value: any, ...args: any[]): string {
    if (value === true) {
      return 'Online'
    } else if (value === false) {
      return 'Offline'
    }
    return StatusCodeLabels[value];
  }

}
